import { createFileRoute, Navigate } from "@tanstack/react-router"
import { SearchBackofficeReferralsSchema } from "./list"

export const Route = createFileRoute("/_base/_auth/backoffice/referrals/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Navigate
      to="/backoffice/referrals/list"
      search={SearchBackofficeReferralsSchema.parse({})}
      replace
    />
  )
}
